<template>
  <div>
    <div class="biFont icon-hidden left"
      :class="{hiddenColor:axisShow}"
      :title="axisShow?'隐藏标尺':'显示标尺'"
      @click="toggleAxisShow"
      :style="{
       width:axisMargin-1+'px',
       height:axisMargin-1+'px'}"></div>
    <canvas
      :class="{hidden:!axisShow}"
      :width="width"
      :height="height"
      ref="ruler"></canvas>
  </div>
</template>
<script>
export default {
	props: {
		width: Number,
		height: Number
	},
	data() {
		return {
			canvas: null,
			context: null,
			axisShow: true,
			bgColor: '#151515',
			axisMargin: 25,//x轴开始的位置 从15开始因为左上角切换隐藏显示按钮15*15
			negativeNum: 21,//负数宽度(按钮结束到圆点的距离)
			negativeNumX: 20,//负数宽度(按钮结束到圆点的距离)
			tickColor: 'grey',
			ticksLineLength: 15,
			ticksLineWidth: .5,
			textColor: 'grey',
			axisLineWidth: 0.8,
			axisColor: '#393f4c',
			cornerTickColor: 'grey',
			cornerTickSpacing: 3,//左上角切换隐藏显示按钮
			cornerTickWidth: .5,
			cornerTickLength: 1,
			heightClic: document.documentElement.clientHeight,
		};
	},
	computed: {
		higherRankSpacing() {
			const obj = {
				1: 50,
				0.9: 60,
				0.8: 80,
				0.7: 120,
				0.6: 160,
				0.5: 200,
				0.4: 250,
				0.3: 300,
				0.2: 400,
				0.1: 500
			};
			return obj[this.scaleLevel];
		},
		scaleLevel() {//缩放等级:0.3-1
			var scaleLevel = this.$store.getters['defaultImgOptions/getScaleLevel'];
			if(scaleLevel == 1){
				return 1
			}else if(scaleLevel == 0.625){
				return 0.6
			}else if(scaleLevel == 0.5){
				return 0.5
			}else if(scaleLevel == 0.3125){
				return 0.3
			}else if(scaleLevel == 0.25){
				return 0.2
			}
		},
		screenWidth() {//屏幕宽度
//			return this.$store.getters['main/getScreenWidth'];
			return 1418;
		},
		screenHeight() {//屏幕高度
//			return this.$store.getters['main/getScreenHeight'];
			return 1079;
		},
		axisWidth() {//x轴宽度
			return this.width - this.axisMargin;
		},
		axisHeigh() {//y轴宽度
			return this.height - this.axisMargin;
		},
		axisOriginX() {//x轴开始的位置
			return this.axisMargin;
		},
		axisOriginY() {//y轴开始的位置
			return this.height;
		},
		xTicksNum() {//x轴刻度数量
			return this.axisWidth / this.xTickSpacing;
		},
		yTicksNum() {//y轴刻度数量
			return this.axisHeigh / this.yTickSpacing;
		},
		xTickSpacing() {//x轴刻度间距
			return (this.higherRankSpacing / 5) * this.scaleLevel;
		},
		yTickSpacing() {//y轴刻度间距
			return (this.higherRankSpacing / 5) * this.scaleLevel;
		},
		xTicksNegativeNum() {//x轴负数刻度数量
			return this.negativeNumX / this.xTickSpacing;
		},
		yTicksNegativeNum() {//y轴负数刻度数量
			return this.negativeNum / this.yTickSpacing;
		}
	},
	mounted() {
		this.canvas = this.$refs.ruler;
		this.context = this.canvas.getContext('2d');
		this.drawAxes();
	},
	methods: {
		drawAxes() {
			let context = this.context;
			context.fillStyle = this.bgColor;
			context.fillRect(0, 0, this.width, this.height);
			context.strokeStyle = this.cornerTickColor;
			context.lineWidth = this.cornerTickWidth;
			this.$options.methods.drawCorner(this, context);
			context.strokeStyle = this.axisColor;
			context.lineWidth = this.axisLineWidth;
			this.$options.methods.drawXaxis(this, context);
			this.$options.methods.drawYaxis(this, context);
			context.lineWidth = this.ticksLineWidth;
			context.strokeStyle = this.tickColor;
			context.fillStyle = this.textColor;
			// this.$options.methods.drawXticksNegative(this, context);
			// this.$options.methods.drawYticksNegative(this, context);
			this.$options.methods.drawXticks(this, context);
			this.$options.methods.drawYticks(this, context);
			context.restore();
		},
		//按钮控制画布隐藏与显示
		toggleAxisShow() {
			this.axisShow = !this.axisShow;
		},
		drawCorner(_this, context) {
			let tickNum = _this.axisMargin / _this.cornerTickSpacing;
			context.beginPath();
			for (var i = 1; i < tickNum; i++) {
				context.moveTo(_this.axisMargin, i * _this.cornerTickSpacing);
				context.lineTo(
					_this.axisMargin - _this.cornerTickLength,
					i * _this.cornerTickSpacing
				);
				context.moveTo(i * _this.cornerTickSpacing, _this.axisMargin);
				context.lineTo(
					i * _this.cornerTickSpacing,
					_this.axisMargin - _this.cornerTickLength
				);
			}
			context.stroke();
		},
		drawXaxis(_this, context) {
			context.beginPath();
			context.moveTo(_this.axisOriginX, _this.axisMargin);
			context.lineTo(_this.width, _this.axisMargin);
			context.stroke();
		},
		drawYaxis(_this, context) {
			context.beginPath();
			context.moveTo(_this.axisOriginX, _this.axisMargin);
			context.lineTo(_this.axisOriginX, _this.axisOriginY);
			context.stroke();
		},
		drawXticks(_this, context) {
			var deltaX;
			let negativeNum = _this.negativeNumX;
			context.beginPath();
			for (var i = 0; i < _this.xTicksNum; ++i) {
				if (i % 5 === 0) {
					deltaX = _this.ticksLineLength;
					context.moveTo(
						_this.axisMargin + _this.xTickSpacing * i + negativeNum,
						1
					);
					context.lineTo(
						_this.axisMargin + _this.xTickSpacing * i + negativeNum,
						10
					);
					context.textAlign = 'left';
					context.font = '10px Verdana';
					context.fillText(
						Math.ceil((i * _this.xTickSpacing) / _this.scaleLevel),
						_this.axisMargin + 5 + _this.xTickSpacing * i + negativeNum,
						10
					);
				context.moveTo(
					_this.axisOriginX + i * _this.xTickSpacing + negativeNum,
					_this.axisMargin
				);
				context.lineTo(
					_this.axisOriginX + i * _this.xTickSpacing + negativeNum,
					_this.axisMargin - deltaX
				);
				} else {
					//deltaX = _this.ticksLineLength / 2;
				}
			}
			context.stroke();
		},
		drawYticks(_this, context) {
			var deltaY;
			let negativeNum = _this.negativeNum;
			context.beginPath();
			for (var i = 0; i < _this.yTicksNum; ++i) {
				if (i % 5 === 0) {
					deltaY = _this.ticksLineLenth;
					context.moveTo(
						_this.axisMargin,
						_this.axisMargin + _this.yTickSpacing * i + negativeNum
					);
					context.lineTo(
						1,
						_this.axisMargin + _this.yTickSpacing * i + negativeNum
					);
					context.textAlign = 'left';
					let j = 0;
					let number = Math.ceil(
						(i * _this.yTickSpacing) / _this.scaleLevel
					).toString();
					let len = number.length,
						textMargin = 10;
					while (j < len) {
						context.fillText(
							number[j],
							5,
							_this.axisMargin +
								15 +
								_this.yTickSpacing * i +
								textMargin * j +
								negativeNum
						);
						j++;
					}
				} else {
					//deltaY = _this.ticksLineLength / 2;
					context.moveTo(
						_this.axisOriginX,
						i * _this.yTickSpacing + _this.axisMargin + negativeNum
					);
					context.lineTo(
						_this.axisOriginX - deltaY,
						i * _this.yTickSpacing + _this.axisMargin + negativeNum
					);
				}
			}
			context.stroke();
		},
		drawXticksNegative(_this, context) {
			var deltaX;
			let negativeNum = _this.negativeNumX;
			context.beginPath();
			for (var i = 1; i < _this.xTicksNegativeNum; ++i) {
				if (i % 5 === 0) {
					deltaX = _this.ticksLineLength;
					context.moveTo(
						_this.axisMargin + negativeNum - _this.xTickSpacing * i,
						1
					);
					context.lineTo(
						_this.axisMargin + negativeNum - _this.xTickSpacing * i,
						10
					);
					context.textAlign = 'left';
					context.fillText(
						i * _this.xTickSpacing,
						_this.axisMargin + negativeNum - _this.xTickSpacing * i + 5,
						10
					);
				} else {
					deltaX = _this.ticksLineLength / 2;
				}
				context.moveTo(
					_this.axisOriginX + negativeNum - i * _this.xTickSpacing,
					_this.axisMargin
				);
				context.lineTo(
					_this.axisOriginX + negativeNum - i * _this.xTickSpacing,
					_this.axisMargin - deltaX
				);
			}
			context.stroke();
		},
		drawYticksNegative(_this, context) {
			var deltaY;
			let negativeNum = _this.negativeNum;
			context.beginPath();
			for (var i = 1; i < _this.yTicksNegativeNum; ++i) {
				if (i % 5 === 0) {
					deltaY = _this.ticksLineLenth;
					context.moveTo(
						_this.axisMargin,
						_this.axisMargin + negativeNum - _this.yTickSpacing * i
					);
					context.lineTo(
						1,
						_this.axisMargin + negativeNum - _this.yTickSpacing * i
					);
					context.textAlign = 'left';
					let j = 0;
					let number = (i * _this.yTickSpacing).toString();
					let len = number.length,
						textMargin = 10;
					while (j < len) {
						context.fillText(
							number[j],
							5,
							_this.axisMargin + 15 + _this.yTickSpacing * i + textMargin * j
						);
						j++;
					}
				} else {
					deltaY = _this.ticksLineLength / 2;
					context.moveTo(
						_this.axisOriginX,
						i * _this.yTickSpacing + _this.axisMargin
					);
					context.lineTo(
						_this.axisOriginX - deltaY,
						i * _this.yTickSpacing + _this.axisMargin
					);
				}
			}
			context.stroke();
		}
	},
	watch: {
		scaleLevel(scale) {
			let context = this.context;
			context.clearRect(this.axisMargin, 0, this.width, this.axisMargin + 1);
			context.clearRect(0, this.axisMargin, this.axisMargin + 1, this.height);
			context.strokeStyle = this.axisColor;
			context.lineWidth = this.axisLineWidth;
			this.drawXaxis(this, context);
			this.drawYaxis(this, context);
			context.lineWidth = this.ticksLineWidth;
			context.strokeStyle = this.tickColor;
			context.fillStyle = this.textColor;
			this.drawXticks(this, context);
			this.drawYticks(this, context);
			context.restore();
		},
		// screenWidth() {
		// 	let context = this.context;
		// 	context.clearRect(this.axisMargin, 0, this.width, this.axisMargin + 1);
		// 	context.clearRect(0, this.axisMargin, this.axisMargin + 1, this.height);
		// 	context.strokeStyle = this.axisColor;
		// 	context.lineWidth = this.axisLineWidth;
		// 	this.drawXaxis(this, context);
		// 	this.drawYaxis(this, context);
		// 	context.lineWidth = this.axisLineWidth;
		// 	this.drawXticks(this, context);
		// 	this.drawYticks(this, context);
		// },
		height(val) {
		  this.$nextTick(()=>{
				let context = this.context;
				context.clearRect(this.axisMargin, 0, this.width, this.axisMargin + 1);
				context.clearRect(0, this.axisMargin, this.axisMargin + 1, this.height);
				context.strokeStyle = this.axisColor;
				context.lineWidth = this.axisLineWidth;
				this.drawXaxis(this, context);
				this.drawYaxis(this, context);
				context.lineWidth = this.ticksLineWidth;
				context.strokeStyle = this.tickColor;
				context.fillStyle = this.textColor;
				this.drawXticks(this, context);
				this.drawYticks(this, context);
				context.restore();

			});
			setTimeout(() => {
			}, 500);
		}
	}
};
</script>
<style scoped>
  .left {
    font-size: 12px;
    color: #fff;
    position: absolute;
    cursor: pointer;
    left: 0;
    top: 0;
    text-align: center;
  }
  
  .icon-hidden{
  	background: url(../../../../assets/image/editor/close.png)no-repeat center;
    background-size: 88%;
  }
  .hiddenColor{
    background: url(../../../../assets/image/editor/eye.png)no-repeat center !important;
    background-size: 100%;
  }
  .hidden{
  	visibility: hidden;
  	
  }
</style>



// WEBPACK FOOTER //
// src/components/MapEditor/canvas/Ruler/Ruler.vue